<template>
    <tr v-if="assetAllocation" class="eamr-row">
        <td class="eamr-asset-cell">
            <div class="eamr-asset-name">
                <i class="fas fa-cube eamr-asset-icon"></i>
                {{ assetAllocation.asset?.name || '—' }}
            </div>
        </td>
        <td class="eamr-asset-cell">
            <span class="eamr-date" v-if="assetAllocation.allocatedDate">
                {{ formatIndianDate(assetAllocation.allocatedDate) }}
            </span>
            <span class="eamr-na" v-else>—</span>
        </td>
        <td class="eamr-asset-cell" >
            <span
                class="eamr-status"
                :class="assetAllocation.returned ? 'eamr-status--returned' : 'eamr-status--allocated'"
            >
                <i :class="assetAllocation.returned ? 'fas fa-check-circle' : 'fas fa-arrow-right'"></i>
                {{ assetAllocation.returned ? "Returned" : "Allocated" }}
            </span>
        </td>
        <td class="eamr-asset-cell" >
            <span class="eamr-date" v-if="assetAllocation.returnedDate">
                {{ formatIndianDate(assetAllocation.returnedDate) }}
            </span>
            <span class="eamr-na" v-else>—</span>
        </td>
        <td class="eamr-actions-cell">
            <button
                class="aa-return-btn"
                :class="{ 'aa-return-disabled': assetAllocation.returned }"
                :disabled="assetAllocation.returned"
                @click="$emit('openReturnModal', assetAllocation)"
            >
                <i class="fas fa-undo-alt"></i> Return
            </button>
        </td>
    </tr>
</template>

<script>
import { formatIndianDate } from "../../utils/common"

export default {
    emits: ["openReturnModal"],
    props: {
        assetAllocation: {
            type: Object,
            default: null,
        },
    },
    methods: {
        formatIndianDate,
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.eamr-asset-cell {
    padding-left: 32px !important;
    padding-right: 32px !important;
}

.eamr-asset-name {
    display: flex;
    align-items: center;
    gap: 7px;
    font-weight: 600;
    color: $gray800;
    font-size: 13px;
}
.eamr-asset-icon {
    color: $primaryColor;
    font-size: 12px;
}
.eamr-date { font-size: 13px; color: $gray600; }
.eamr-na   { font-size: 13px; color: $gray400; }

/* Status Badge */
.eamr-status {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;

    &--allocated { background: #dbeafe; color: #1d4ed8; }
    &--returned  { background: #dcfce7; color: #15803d; }
}

/* Return button — matches aa-return-btn from asset-allocations.vue */
.eamr-actions-cell { text-align: center; }

.aa-return-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 12px;
    border: 1px solid $gray200;
    border-radius: 5px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all $transitionFast;
    font-family: inherit;
    background: white;
    color: #7c3aed;

    i { font-size: 10px; }

    &:hover:not(:disabled) {
        background: #f5f3ff;
        border-color: rgba(124, 58, 237, 0.15);
    }
}
.aa-return-disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
    color: $gray400;
}
</style>
